import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Info, Warning } from '@picsio/icons';

import s from './ConversionDialogPresetInfo.module.scss';

export default function ConversionDialogPresetInfo({ children, variant }) {
  const isWarning = variant === 'warning';
  const IconComponent = isWarning ? Warning : Info;

  return (
    <div className={cn(s.root, { [s.warning]: isWarning })} role="note">
      <IconComponent className={s.icon} aria-hidden />
      <div className={s.text}>{children}</div>
    </div>
  );
}

ConversionDialogPresetInfo.defaultProps = {
  variant: 'info',
};

ConversionDialogPresetInfo.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['info', 'warning']),
};
